import { useState, useEffect } from 'react';
import { publicApi } from '@/lib/api';
import { FadeIn } from '@/components/FadeIn';
import { useContentValue } from '@/contexts/SiteContentContext';
import { Loader2 } from 'lucide-react';

export default function GallerySection() {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const c = useContentValue();

  useEffect(() => {
    publicApi.getImages('gallery').then((res) => setImages(res.data.images || []))
      .catch(() => {}).finally(() => setLoading(false));
  }, []);

  const getSpan = (i) => {
    if (i === 0) return 'col-span-2 row-span-2';
    return 'col-span-1 row-span-1';
  };

  return (
    <section id="galerie" data-testid="gallery-section" className="py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6">
        <FadeIn>
          <div className="text-center mb-16">
            <span className="text-amber-400 text-xs tracking-[0.3em] uppercase font-body">{c('Galerie.Eyebrow', 'Galerie')}</span>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-stone-100 mt-3 tracking-wide uppercase">{c('Galerie.Überschrift', 'Impressionen')}</h2>
            <p className="text-stone-400 text-base max-w-lg mx-auto mt-4 font-body">{c('Galerie.Beschreibung', 'Ein Blick in unsere Welt. So sieht es bei uns aus.')}</p>
          </div>
        </FadeIn>
        {loading ? (
          <div className="flex justify-center py-16"><Loader2 size={32} className="text-amber-400 animate-spin" /></div>
        ) : (
          <FadeIn delay={150}>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4 auto-rows-[180px] sm:auto-rows-[220px]">
              {images.map((img, i) => (
                <div key={img.id || i} data-testid={`gallery-image-${i}`} className={`${getSpan(i)} rounded-xl overflow-hidden img-zoom group relative`}>
                  <img src={img.image_url} alt={`${img.name} – Impression aus dem TreffPunkt Luzern`} className="w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-500 flex items-end p-4">
                    <span className="text-white text-sm font-body opacity-0 group-hover:opacity-100 transition-opacity duration-300 translate-y-2 group-hover:translate-y-0">{img.name}</span>
                  </div>
                </div>
              ))}
            </div>
          </FadeIn>
        )}
      </div>
    </section>
  );
}
